import withToggle from './withToggle';
import Info from './Info';



/**
 *
 */
export default withToggle(Info);
